export enum PaisMercadoGlobalEnum {
  BRA = 0,
  EUA = 1,
  CHL, // Chile
  PRY, // Paraguai
  PER, // Peru
  COL, // Colômbia
  MEX, // México
  CAN, // Canadá
  JPN, // Japão
  GBR, // Reino Unido
  DEU, // Alemanha
  FRA, // França
  ESP, // Espanha
  ITA, // Itália
  NLD, // Países Baixos (Holanda)
  POL, // Polônia
  BEL, // Bélgica
  SWE, // Suécia
  DNK, // Dinamarca
  NOR, // Noruega
  FIN, // Finlândia
  AUT, // Áustria
  IRL, // Irlanda
  PRT, // Portugal
  CHE, // Suíça
  LUX, // Luxemburgo
  MCO, // Mônaco
}

export const PaisMercadoGlobalDescricao: {
  [key in PaisMercadoGlobalEnum]: string;
} = {
  [PaisMercadoGlobalEnum.BRA]: 'Brasil',
  [PaisMercadoGlobalEnum.EUA]: 'Estados Unidos',
  [PaisMercadoGlobalEnum.CHL]: 'Chile',
  [PaisMercadoGlobalEnum.PRY]: 'Paraguai',
  [PaisMercadoGlobalEnum.PER]: 'Peru',
  [PaisMercadoGlobalEnum.COL]: 'Colômbia',
  [PaisMercadoGlobalEnum.MEX]: 'México',
  [PaisMercadoGlobalEnum.CAN]: 'Canadá',
  [PaisMercadoGlobalEnum.JPN]: 'Japão',
  [PaisMercadoGlobalEnum.GBR]: 'Reino Unido',
  [PaisMercadoGlobalEnum.DEU]: 'Alemanha',
  [PaisMercadoGlobalEnum.FRA]: 'França',
  [PaisMercadoGlobalEnum.ESP]: 'Espanha',
  [PaisMercadoGlobalEnum.ITA]: 'Itália',
  [PaisMercadoGlobalEnum.NLD]: 'Países Baixos (Holanda)',
  [PaisMercadoGlobalEnum.POL]: 'Polônia',
  [PaisMercadoGlobalEnum.BEL]: 'Bélgica',
  [PaisMercadoGlobalEnum.SWE]: 'Suécia',
  [PaisMercadoGlobalEnum.DNK]: 'Dinamarca',
  [PaisMercadoGlobalEnum.NOR]: 'Noruega',
  [PaisMercadoGlobalEnum.FIN]: 'Finlândia',
  [PaisMercadoGlobalEnum.AUT]: 'Áustria',
  [PaisMercadoGlobalEnum.IRL]: 'Irlanda',
  [PaisMercadoGlobalEnum.PRT]: 'Portugal',
  [PaisMercadoGlobalEnum.CHE]: 'Suíça',
  [PaisMercadoGlobalEnum.LUX]: 'Luxemburgo',
  [PaisMercadoGlobalEnum.MCO]: 'Mônaco',
};


export const LOCALE_BY_COUNTRY_ENUM: Record<PaisMercadoGlobalEnum, string> = {
  [PaisMercadoGlobalEnum.BRA]: 'pt-BR',
  [PaisMercadoGlobalEnum.EUA]: 'en-US',
  [PaisMercadoGlobalEnum.CHL]: 'es-CL',
  [PaisMercadoGlobalEnum.PRY]: 'es-PY',
  [PaisMercadoGlobalEnum.PER]: 'es-PE',
  [PaisMercadoGlobalEnum.COL]: 'es-CO',
  [PaisMercadoGlobalEnum.MEX]: 'es-MX',
  [PaisMercadoGlobalEnum.CAN]: 'en-CA',
  [PaisMercadoGlobalEnum.JPN]: 'ja-JP',
  [PaisMercadoGlobalEnum.GBR]: 'en-GB',
  [PaisMercadoGlobalEnum.DEU]: 'de-DE',
  [PaisMercadoGlobalEnum.FRA]: 'fr-FR',
  [PaisMercadoGlobalEnum.ESP]: 'es-ES',
  [PaisMercadoGlobalEnum.ITA]: 'it-IT',
  [PaisMercadoGlobalEnum.NLD]: 'nl-NL',
  [PaisMercadoGlobalEnum.POL]: 'pl-PL',
  [PaisMercadoGlobalEnum.BEL]: 'nl-BE',
  [PaisMercadoGlobalEnum.SWE]: 'sv-SE',
  [PaisMercadoGlobalEnum.DNK]: 'da-DK',
  [PaisMercadoGlobalEnum.NOR]: 'nb-NO',
  [PaisMercadoGlobalEnum.FIN]: 'fi-FI',
  [PaisMercadoGlobalEnum.AUT]: 'de-AT',
  [PaisMercadoGlobalEnum.IRL]: 'en-IE',
  [PaisMercadoGlobalEnum.PRT]: 'pt-PT',
  [PaisMercadoGlobalEnum.CHE]: 'fr-CH',
  [PaisMercadoGlobalEnum.LUX]: 'fr-LU',
  [PaisMercadoGlobalEnum.MCO]: 'fr-MC',
};

export const resolveCheckoutLocale = (
  paisEnum?: PaisMercadoGlobalEnum,
  fallback = 'en-US',
) => {
  if (paisEnum === undefined || paisEnum === null) return fallback;
  return LOCALE_BY_COUNTRY_ENUM[paisEnum] || fallback;
};